import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import './composables/useTheme'; // applique le theme au boot
import './composables/usePwaInstall'; // capture beforeinstallprompt au plus tôt
import './styles/main.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.mount('#app');

// Tente une session existante via cookie httpOnly au boot
import { useAuthStore } from '@/stores/authStore';
const authStore = useAuthStore();
authStore.init();

// Le Service Worker est enregistré dans App.vue (useRegisterSW) — une seule inscription,
// pas ici : un doublon avait réintroduit un reload forcé sur mise à jour SW (cf. commentaire
// dans App.vue), qui annulait le fix du bug "délogué après connexion" (2026-08-21).
